import { Navigate, useSearchParams } from 'react-router-dom'

type LegacyAliasRedirectProps = {
  idParam: string
  destinationBase: string
  destinationSuffix?: string
  fallbackTo?: string
}

export function LegacyAliasRedirect({
  idParam,
  destinationBase,
  destinationSuffix = '',
  fallbackTo = '/',
}: LegacyAliasRedirectProps) {
  const [searchParams] = useSearchParams()
  const id = String(searchParams.get(idParam) || '').trim()
  if (!id) {
    return <Navigate to={fallbackTo} replace />
  }

  const q = new URLSearchParams()
  searchParams.forEach((value, key) => {
    if (key === idParam) return
    q.append(key, value)
  })
  const suffix = q.toString()
  return (
    <Navigate
      to={`${destinationBase}/${encodeURIComponent(id)}${destinationSuffix}${suffix ? `?${suffix}` : ''}`}
      replace
    />
  )
}
